import React from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
import {
  useAuth,
  RegisterAndActivateCouponConnectorApollo,
  UserDataConnectorApollo,
} from '@front-activerse/common-components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SignupAndActivateProductContainer from './SignupAndActivateProductContainer';

interface ISignupAndActivateProductPage {
  pathActiveProduct: string;
  displayAppleButton?: boolean;
  displayFacebookButton?: boolean;
  displayGoogleButton?: boolean;
}

const SignupAndActivateProductPage: React.FC<ISignupAndActivateProductPage> = ({
  pathActiveProduct,
  displayAppleButton = true,
  displayFacebookButton = true,
  displayGoogleButton = true,
}) => {
  const { isAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth) {
      navigate(pathActiveProduct);
    }
  }, []);

  return (
    <RegisterAndActivateCouponConnectorApollo>
      {({
        registerAndActivateCoupon,
      }: {
        registerAndActivateCoupon: (request: any) => Promise<any>;
      }) => (
        <UserDataConnectorApollo>
          {({ ...userDataOnDemand }: { userDataOnDemand: any }) => (
            <SignupAndActivateProductContainer
              displayAppleButton={displayAppleButton}
              displayFacebookButton={displayFacebookButton}
              displayGoogleButton={displayGoogleButton}
              registerAndActivateCoupon={registerAndActivateCoupon}
              pathActiveProduct={pathActiveProduct}
              {...userDataOnDemand}
            />
          )}
        </UserDataConnectorApollo>
      )}
    </RegisterAndActivateCouponConnectorApollo>
  );
};

export default SignupAndActivateProductPage;
